import { HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PopupType } from 'src/app/core/models/common.models';
import { RestService } from 'src/app/core/services/rest.service';
import { EventType, IEventReview, IPopupInputForm } from '../../models/passport.models';
import { Profile, Stamp } from '../../models/profile.model';
import { EventReviewService } from '../../services/event-review.service';
import { PassportService } from '../../services/passport.service';

@Component({
  selector: 'app-stamps-box',
  templateUrl: './stamps-box.component.html',
  styleUrls: ['./stamps-box.component.css'],
})
export class StampsBoxComponent implements OnInit {
  @Input() label: string;
  @Input() stamps: Array<Stamp>;
  @Input() eventType: EventType;
  @Input() communityPassport: Profile;
  @Input() comingSoonImage: string;

  @Output() refreshEventState: EventEmitter<boolean> = new EventEmitter(false);

  public showStampDetails = false;
  public popupType = PopupType.EVENT_REVIEW;
  public selectedStamp: Stamp;

  constructor(private passportService: PassportService,
              private eventReviewService: EventReviewService) {}

  ngOnInit(): void {}

  handleStampClick(stamp: any): void {
    console.log('stamp clicked:', stamp);

    const eventReviewPromise = this.communityPassport
      ? this.passportService.getCommunityPassportReview(stamp.eventId, this.eventType, this.communityPassport.userId)
      : this.passportService.getEventReview(stamp.eventId, this.eventType);

    eventReviewPromise.then(response => {
      if (response.error) {
        this.selectedStamp = stamp;
        this.showStampDetails = true;
      } else {
        this.selectedStamp = stamp;
        this.selectedStamp.review = response;
        this.showStampDetails = true;
      }
    }).catch(() => {
      this.selectedStamp = stamp;
      this.showStampDetails = true;
    });

    // this.router.navigate(['/passport', 'spotlight-event-stamp']);
  }

  togglePopupState(): void {
    this.showStampDetails = false;
  }

  public async handlePopupInputFormData(event: IPopupInputForm): Promise<void> {
    this.showStampDetails = false;

    if (event.popupForm.favoriteState) {
      const status = await this.eventReviewService.handleFavoriteEventState(event);
      this.refreshEventState.emit(status);
    } else {
      const response = await this.eventReviewService.handleEventReviewPopup(event);
      this.selectedStamp.review = response.review;
      this.showStampDetails = response.showPopup;
    }
  }
}
